/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GenerateFamilyMemberPinPathParameters } from 'api/actions/generate-family-member-pin/generate-family-member-pin-path-parameters';
import { GenerateFamilyMemberPinResponse } from 'api/actions/generate-family-member-pin/generate-family-member-pin-response';

type GenerateFamilyMemberPinQueryParameters = Record<string, any>;

/**
 * The path of the GenerateFamilyMemberPin action.
 */
export const generateFamilyMemberPinActionPath = new SweetPath<keyof GenerateFamilyMemberPinPathParameters>(
  '/user/family/members/{userId}/pin/generate',
  { path: '{param}' }
);

/**
 * Creates a contextualized GenerateFamilyMemberPin actions.
 */
export default function createGenerateFamilyMemberPinAction(axios: AxiosInstance) {
  return function generateFamilyMemberPinAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GenerateFamilyMemberPinPathParameters;
    query?: GenerateFamilyMemberPinQueryParameters;
  }) {
    const path = generateFamilyMemberPinActionPath.insert(parameters);

    return axios.post<GenerateFamilyMemberPinResponse, GenerateFamilyMemberPinResponse>(path, {
      params: query,
      headers,
    });
  };
}
